import styled from 'styled-components'

export const Header = styled.header`
  display: flex; align-items: center; justify-content: space-between; gap: 16px;
  padding: 16px 28px; border-bottom: 1px solid #dfe6f0; background: #fff;
  > img { width: 112px; height: auto; }
  .signed-in { display: flex; align-items: center; gap: 9px; color: #65748c; font-size: 12px; overflow-wrap: anywhere; }
  .ant-avatar { flex-shrink: 0; background: #e4edf9; color: #0e4ea7; }
  @media (max-width: 760px) {
    padding: 14px 16px;
    .signed-in > span:not(.ant-avatar) { display: none; }
  }
`
